import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import 'reflect-metadata'
import './antd'
import globalComponents from './components'
import './vue.proto'

const { NODE_ENV, TARGET } = process.env

Vue.config.productionTip = false
Vue.config.devtools = NODE_ENV === 'development' || TARGET === 'test-build'
Vue.use(Viewer)
Vue.use(globalComponents)

const vm: any = new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
;(window as any).$appVm = vm
